import React, { useState, useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import Spinner from 'react-bootstrap/Spinner';
import { toast } from 'react-toastify';



import 'react-datepicker/dist/react-datepicker.css';
import { useForm, Controller, Feedback } from 'react-hook-form';
import axios from 'axios';


import { NavLink, useLocation } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import TableComponent from '../../components/Mensualidades/Filtrado';
import { URL_EMPLOYEE } from '../../constans/servidor';
import { set } from 'immutable';



const BuscadorComponen = props => {
  const { Contrato, info } = props
  const [data, setData] = useState();
  const [nit,setNit]=useState();
  const [objetos, setObjetos] = useState();
  const [datos, setDatos] = useState();
  const [loadingData, setLoadingData] = useState(false);
  const [placa, setPlaca] = useState();
  const [park, setPark] = useState('');
  const [placas, setPlacas] = useState();
  // const [Terminales, setTerminales] = useState();
  const [verTipo, setVerTipo] = useState(0);
  const [verTabla, setVerTabla] = useState(0);
  const [errorMessageA, setErrorMessageA] = useState('');
  const [errorMessageB, setErrorMessageB] = useState('');
  const [datosCorrectosA, setdatosCorrectosA] = useState(false);
  const [datosCorrectosB, setdatosCorrectosB] = useState(false);
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState('');
  const [texto, setlabel] = useState('');
  const [fecha, setFecha] = useState('');
  const [estados, setEstado] = useState()



  const {
    control,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const opcion = (val) => {
    setVerTipo(parseInt(val.value));
  }


  const onSubmit = async (data) => {
    console.log(data)
    const parametros = {
      idMonthlyContract: parseInt(data.contratos.value),
    }
    setLoading(true)
    try {
      const resultado = await axios.post(`${URL_EMPLOYEE}/monthlyInstallment/list/lpr/listPlate`, parametros)
      setLoading(false)
      setDatos(false)
      console.log('result');
      console.log(resultado);
      console.log(info);
      resul(resultado)

      function resul(resultado) {
        if (resultado.data) {
          const foundObject = info.find((obj) => obj.idMonthlyContract === parametros.idMonthlyContract);
          setNit(foundObject)
          setVerTabla(1);
          setVerTipo(0)
          const objeto = resultado.data["data"]
          setData(objeto)
          setErrorMessageA('');
          setErrorMessageB('');
        } else {
          toast.error('No se encontro el parquedaero ');
          setVerTipo(0)

        }
      }
      reset({
        cod_park: '',
      });
    } catch (error) {
      toast.error('Algo salio mal..');
      setLoadingData(false);
    }
  }
  useEffect(() => {
    setTimeout(() => {
      setLoading(false)
    }, 800);

  }, []);
  return loading ? (
    <div className="cargando">
      <div className="loader" id="loader">
        Loading...
      </div>
    </div>
  ) : (
    <>
      <Container >
        <form onSubmit={handleSubmit(onSubmit)}>
          {Contrato ? (
            <Row className="contenedorT-Filtrado">
              <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                <Form.Group controlId="formBasicEmail">
                  <Form.Label className='texto-label'>Parqueadero</Form.Label>
                  <Controller
                    name="contratos"
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: 'El campo es obligatorio',
                      }
                    }}
                    // rules={{ required: true }}
                    defaultValue=""
                    render={({ field: { onChange, onBlur, value } }) => (
                      <Select
                        onChange={(data) => {
                          onChange(data);
                        }}
                        value={value}
                        // placeholder="Elige una opción"
                        options={Contrato}
                      />

                    )}
                  />
                  {errors.contratos && (
                    <Form.Text id="passwordHelpBlock" className="error">
                      El campo es obligatorio
                    </Form.Text>
                  )}
                </Form.Group>
              </Col>

            </Row>
          ) : null}
          <Row className="justify-content-end mbottom-20">
            <Button type="submit" variant="primary" className=" btn btn-primary mtop-20 boton"
            >
              {loadingData ? (
                <Spinner animation="border" size="sm" />
              ) : (
                'Consultar Placas'
              )}
            </Button>
          </Row>
        </form>
      </Container>
      {verTabla === 1 ? (
        <>
          <Row className="mtop-40">
            {park !== '' ? (
              <Col xs={12} sm={12} md={8} lg={8} xl={8}>
                <p className='texto-subtitulo'>Parqueadero:<span className='span'> {park}</span> </p>
              </Col>
            ) : null}
          </Row>


          <TableComponent data={data} nit={nit} />


        </>
      ) :
        null}

    </>
  );

};
export default BuscadorComponen;